import React, { useEffect } from 'react';
import ShippingService from '../services/shipping';
import $ from 'jquery';
import DatePiCker from 'react-datepicker';
import AuthorizationCheck from '../auth/authorizationCheck';
import SupplierService from '../services/supplier';


class Shipment extends React.Component {


    constructor(props) {
        super(props);

        this.shippingService = new ShippingService();

        this.state = {
            shippingDate: new Date(),
            eta: new Date(),
            currentUserRole : '',
            suppliers: [],
            branches: []
            
        };
    }

    componentDidMount(){

        this.suppliers();
    }

    setRole = (role) => {

        this.setState({ currentUserRole : role });
    }

   

    setShippingDate = (date) => {

        this.setState({ shippingDate: date })
    }

    setEta = (date) => {

        this.setState({ eta: date })
    }


    suppliers = async () =>{

        const response = await SupplierService.supplierList();

        this.setState({

            suppliers: await response.json()
        })
    }

    branches = async () =>{

        let countryId = $('#destinationCountryId').val();

        const response = await this.props.branchService.branchList(countryId);

         this.setState({

            branches: await response.json()
        })
    }

    render() {

        const branches = this.state.branches;

        return (
            <div className="container">
                <AuthorizationCheck accessLevel='ADMIN'  userRole= { this.setRole } />
                <div className="form-wrapper">

                </div>

                <div className="shipment-wrapper">
                    <div className="form-wrapper">
                        <h2>Crée un nouveau chargement</h2>
                        <div className="messageHolder"></div>
                        <div className="form-group">

                            <input type="text" className="form-control" id="ccontainerId" placeholder="Numero du Conteneur" />

                        </div>

                        <div className="form-group">

                            <input type="text" className="form-control" id="cdescription" placeholder="Description" />

                        </div>

                        <div className="form-group">
                            <DatePiCker id="shippingDate" dateFormat="yyyy-MM-dd" selected={this.state.shippingDate} placeholderText="Date d'embarquement" className="form-control" onChange={this.setShippingDate} />
                        </div>

                        <div className="form-group">
                            <DatePiCker id="eta" dateFormat="yyyy-MM-dd" selected={this.state.eta} placeholderText="Date d'arrivée" className="form-control" onChange={this.setEta} />
                        </div>


                        <div className="form-group">
                            <label className="label">Fournisseur</label>
                            <select className="form-control full-width" id="supplierId">
                                <option></option>
                                {this.state.suppliers != null && this.state.suppliers.length > 0 && this.state.suppliers.map(supplier => 

                                    <option key={supplier.supplierId} value={supplier.supplierId }>{ supplier.name }</option>
                                    
                                    )}
                            </select>

                        </div>
                        


                        <div className="form-group">
                            <label className="label">Origine</label>
                            <select className="form-control full-width" id="originCountryId">
                                <option></option>
                                {this.props.countries != null && this.props.countries.map(country => 
                                    <option value={country.countryId}>{country.name}</option>
                                )}
                                
                            </select>

                        </div>

                        <div className="form-group">
                            <label className="label">Destination</label>
                            <select className="form-control full-width" id="destinationCountryId" onChange={this.branches}>
                                <option></option>
                                {this.props.countries != null && this.props.countries.map(country => 
                                    <option value={country.countryId}>{country.name}</option>
                                )}

                            </select>

                        </div>

                        <div className='form-group'>
                        <label className="label">Branches</label>
                        <select className='form-control' id='branchId'>
                            <option></option>

                            {branches.length > 0 && branches.map(branch =>

                                <option value={branch.branchId}> {branch.name} </option>

                            )}

                        </select>



                    </div>


                        <div className="form-group">
                            <button className="btn btn-primary full-width" onClick={this.props.createShipment}>Create</button>
                        </div>


                    </div>
                </div>

            </div>
        )
    }
}

export default Shipment;